import React from "react";

export const WeddingCalculatorHeader = ({ t }) => (
  <div className="flex items-center justify-between"></div>
);
